import { Injectable, inject } from '@angular/core';
import {environment} from '@environments/environment';
import {HttpClient} from '@angular/common/http';
import {Organization} from '@app/modules/shared/models';

@Injectable({providedIn: 'root'})
export class OrganizationService {
  private http = inject(HttpClient);

  private baseApiUrl = environment.apiUrl;
  private organizationUrl = this.baseApiUrl + '/api/v1/organization';

  getOrganizations(params: any = {}) {
    return this.http.get(`${this.organizationUrl}`, {params});
  }

  getOrganization(id: number) {
    return this.http.get(`${this.organizationUrl}/${id}`);
  }

  deleteOrganization(organizationId: number) {
    return this.http.delete(`${this.organizationUrl}/${organizationId}`);
  }

  updateOrganization(organizationId: number, organization: Organization) {
    return this.http.put(`${this.organizationUrl}/${organizationId}`, organization);
  }

  addOrganization(organization: Organization) {
    return this.http.post(`${this.organizationUrl}`, organization);
  }
}
